import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, Send } from "lucide-react";
import { api, errorMessage } from "../lib/api";

export default function AdminNotify() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subject, setSubject] = useState("Sugary Sweet — New orders are open!");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);

  const load = () => {
    setLoading(true);
    api.get("/admin/notify-subscribers").then(r => setSubs(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const blast = async (e) => {
    e.preventDefault();
    if (!body.trim() || !subject.trim()) return;
    if (!confirm(`Send this to all ${subs.length} subscribers?`)) return;
    setSending(true);
    try {
      const { data } = await api.post("/admin/notify-blast", { subject, body });
      toast.success(`Sent to ${data.sent} of ${data.total_subscribers} subscribers`);
      setBody("");
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setSending(false); }
  };

  return (
    <div data-testid="admin-notify">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h1 className="font-display font-extrabold text-3xl md:text-4xl">Notify List</h1>
          <p className="text-gray-500 mt-1 text-sm">Visitors who opted in from the homepage popup to get alerts when new orders open.</p>
        </div>
        <div className="text-right">
          <p className="text-xs uppercase tracking-widest font-bold text-[#FF1F87]">Subscribers</p>
          <p className="font-display font-extrabold text-3xl">{loading ? "…" : subs.length}</p>
        </div>
      </div>

      <form onSubmit={blast} className="bg-white border border-gray-100 rounded-2xl p-5 mb-6 max-w-2xl">
        <h2 className="font-display font-extrabold text-lg flex items-center gap-2 mb-3"><Send className="w-4 h-4 text-[#FF1F87]" /> Broadcast to subscribers</h2>
        <label className="block">
          <span className="text-xs uppercase tracking-widest font-bold text-[#4B5563]">Subject</span>
          <input className="input-base mt-1" value={subject} onChange={e => setSubject(e.target.value)} required data-testid="notify-subject" />
        </label>
        <label className="block mt-3">
          <span className="text-xs uppercase tracking-widest font-bold text-[#4B5563]">Message</span>
          <textarea className="input-base mt-1 min-h-[140px]" value={body} onChange={e => setBody(e.target.value)} placeholder="New orders are open! This week we have Brown Butter Chocolate Chip, Brookies & Cream, Cake Batter, and Snickerdoodle. Order by Thursday at 8pm." required data-testid="notify-body" />
        </label>
        <button type="submit" disabled={sending || subs.length === 0} className="btn-pink mt-4 inline-flex items-center" data-testid="notify-blast-btn">
          <Bell className="w-4 h-4 mr-2" /> {sending ? "SENDING..." : `BROADCAST TO ${subs.length} SUBSCRIBERS`}
        </button>
      </form>

      <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-100">
            <tr className="text-left">
              <th className="px-4 py-3 text-xs uppercase tracking-wider font-bold text-gray-500">Email</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider font-bold text-gray-500">Phone</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider font-bold text-gray-500">Joined</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {loading && <tr><td colSpan="3" className="p-6 text-center text-gray-500">Loading…</td></tr>}
            {!loading && subs.length === 0 && <tr><td colSpan="3" className="p-6 text-center text-gray-500">No subscribers yet. Enable the homepage popup and people can join from there.</td></tr>}
            {subs.map(s => (
              <tr key={s.id} className="hover:bg-gray-50" data-testid={`notify-row-${s.id}`}>
                <td className="px-4 py-3 font-semibold">{s.email}</td>
                <td className="px-4 py-3 text-gray-600">{s.phone || "—"}</td>
                <td className="px-4 py-3 text-gray-500 text-xs">{new Date(s.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
